const DEFAULT_ITEMS = "React, React Native, Flutter, Next.js, Node.js, Stripe, AWS, PostgreSQL";

export default function TechMarqueeSection({ props = {} }) {
  const items = (props.items || DEFAULT_ITEMS).split(",").map((s) => s.trim()).filter(Boolean);
  return (
    <section className="border-y border-stone/80 overflow-hidden py-5 bg-white/40">
      <div className="flex w-max lm-marquee">
        {[...items, ...items].map((t, i) => (
          <span key={i} className="font-mono text-lg tracking-wide text-ash whitespace-nowrap px-8">{t}</span>
        ))}
      </div>
    </section>
  );
}
